export default __webpack_public_path__ + "static/media/national-park.577d2db1.svg";